'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.launchDarklyClientSideIds = undefined;

var _domain = require('../enums/domain');

var _a;
var launchDarklyClientSideIds = exports.launchDarklyClientSideIds = (_a = {}, _a[_domain.Domain.DEVELOPMENT] = '5bc6b03387604940586b904f', _a[_domain.Domain.TEAM] = '5bc6b03387604940586b904f', _a[_domain.Domain.STAGING] = '5bc6fa3a8bd00640d256dab0', _a[_domain.Domain.PRODUCTION] = '5bc6b03387604940586b9050', _a);
//# sourceMappingURL=launch-darkly.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/web-ui/dist/config/data/launch-darkly.js
// module id = 1993
// module chunks = 0